import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "The City",
    body:
      "A stitched-together map of London, Manchester and everywhere in between. Council estates, high-rises, corner shops, motorway service stations at 3am. The setting isn't a backdrop — it's a character.",
    image:
      "https://images.pexels.com/photos/35161204/pexels-photo-35161204.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    num: "02",
    title: "The Code",
    body:
      "Fair play, sharp roleplay, zero tolerance for RDM and metagaming. Staff on 24/7. Every arc has consequences — the streets remember.",
    image:
      "https://images.unsplash.com/photo-1570984066691-54e56650764d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxtZXQlMjBwb2xpY2UlMjBoZWxpY29wdGVyJTIwbmlnaHR8ZW58MHx8fHwxNzg0OTk4OTYyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    num: "03",
    title: "The Crew",
    body:
      "Postcodes, syndicates, MET, ambulance, mechanics, journos. Pick a side or build your own. We supply the metal, the loadouts and the interiors — you supply the story.",
    image:
      "https://images.pexels.com/photos/11808087/pexels-photo-11808087.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
];

function Chapter({ num, title, body, image, i }) {
  return (
    <div
      data-testid={`manifesto-chapter-${num}`}
      className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-16 md:py-28 border-b border-white/5 ${
        i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
      }`}
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
        className="md:col-span-7 relative"
      >
        <div className="relative overflow-hidden aspect-[16/10] md:aspect-[16/9]">
          <img src={image} alt={title} className="w-full h-full object-cover grayscale-[0.7] contrast-125" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          <div className="absolute top-4 left-4 tag-chip">CHAPTER {num}</div>
        </div>
      </motion.div>

      <div className="md:col-span-5 flex flex-col justify-center">
        <div className="chapter-number mb-4 select-none">{num}</div>
        <motion.h3
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-4xl md:text-6xl text-white leading-none tracking-tight mb-6 uppercase"
        >
          {title}
        </motion.h3>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="text-zinc-400 text-base leading-relaxed max-w-md"
        >
          {body}
        </motion.p>
      </div>
    </div>
  );
}

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto" className="max-w-[1440px] mx-auto px-6 md:px-10">
      <div className="py-16 md:py-24 flex items-end justify-between">
        <div>
          <div className="eyebrow mb-4">/ MANIFESTO</div>
          <h2 className="font-display text-5xl md:text-7xl text-white tracking-tighter leading-[0.9]">
            The Ends,<br />documented.
          </h2>
        </div>
        <div className="hidden md:block font-mono text-[10px] tracking-[0.28em] uppercase text-zinc-500 text-right">
          THREE CHAPTERS<br />ONE CITY<br />NO JUSTICE
        </div>
      </div>
      {CHAPTERS.map((c, i) => (
        <Chapter key={c.num} {...c} i={i} />
      ))}
    </section>
  );
}
